import { type Dispatch, type MouseEvent, type SetStateAction } from "react";

import { type Subscription, fromEvent } from "rxjs";
import { delay, tap } from "rxjs/operators";

export const temporaryTooltipHandler = (
    spanEl: HTMLSpanElement | null,
    callbackAction: () => void,
    setVisible: Dispatch<SetStateAction<boolean>>,
): Subscription | null =>
    spanEl
        ? fromEvent<MouseEvent<HTMLSpanElement>>(spanEl, "click")
              .pipe(
                  tap(() => {
                      callbackAction();
                      setVisible(true);
                  }),
                  delay(1000),
                  tap(() => {
                      setVisible(false);
                  }),
              )
              .subscribe()
        : null;
